export function pixelsToUnits(px, camera, windowHeight, z = null) {
  const dist = z ?? camera.position.z;
  const fov = camera.fov;
  const height = 2 * dist * Math.tan(fov * 0.5 * (Math.PI / 180));
  const units = (px / windowHeight) * height;

  return units;
}
